import React, {useState} from 'react';
import {Card, Table} from "antd";
import { Modal, useAppState } from '@nutastic/nutastic-react-app';
import AccountsTabSection from "./AccountsTabSection";
import UserInformationForm from "./UserInformationForm";
import UserCredentialsForm from "./UserCredentialsForm";

const componentClass = 'accountSettings';

const CARD_CONTENT_IDS = {
    USER_INFO: 'USER_INFO',
    CREDENTIALS: 'CREDENTIALS',
    ORDERS: 'ORDERS'
};

const AccountSettings = () => {
    const [ activeCardId, setActiveCardId ] = useState(null);
    const { authState } = useAppState();
    const { accountInfo } = authState;
    const { firstname, lastname, email, products = [] } = accountInfo;

    const tableColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            render: (text, record) => <span>{record.date}</span>,
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            defaultSortOrder: 'descend'
        },
        {
            title: 'Name',
            dataIndex: 'title',
            render: (text, record) => <span><b>{record.title}</b></span>,
            sorter: (a, b) => a.title.localeCompare(b.title)
        },
        {
            title: 'Type',
            dataIndex: 'productType',
            render: (text, record) => <span>{record.productType}</span>,
        },
        {
            title: 'Amount',
            dataIndex: 'amountPaid',
            render: (text, record) => <span>${record.amountPaid}</span>,
        },
    ];

    const orderHistoryTable = <div className="accountsTableWrapper">
        <h2>Order History</h2>
        <Table
            columns={tableColumns}
            dataSource={products}
            rowKey={'id'}
            pagination={{ pageSize: 5 }}
            className="tableList"
        />
    </div>;

    const cardContentItems = {
        [CARD_CONTENT_IDS.USER_INFO]: {
            id: CARD_CONTENT_IDS.USER_INFO,
            children: <UserInformationForm formValues={{ email, firstName: firstname, lastName: lastname }} onClose={() => setActiveCardId(null)} />
        },
        [CARD_CONTENT_IDS.CREDENTIALS]: {id: CARD_CONTENT_IDS.CREDENTIALS, children: <UserCredentialsForm onClose={() => setActiveCardId(null)} />},
        [CARD_CONTENT_IDS.ORDERS]: {id: CARD_CONTENT_IDS.ORDERS, children: orderHistoryTable}
    };

    return <section className={componentClass}>
        <AccountsTabSection title="Account Details" text="Manage your credentials, account information, and more">
            <div className="account-cards">
                <Card title="Your Information" className={`${componentClass}__card accountInfoCard`}>
                    <div className="cardIcon"><i className="fa fa-info" /></div>
                    <p>Manage your personal information (i.e. name, email, etc)</p>
                    <div className="cardButtons">
                        <button className="btn btn-small btn-outline-primary" onClick={() => setActiveCardId(CARD_CONTENT_IDS.USER_INFO)}>
                            <i className="fa fa-pencil mr-2" /> Edit Info
                        </button>
                    </div>
                </Card>

                <Card title="Change Your Credentials" className={`${componentClass}__card accountInfoCard`}>
                    <div className="cardIcon"><i className="fa fa-key" /></div>
                    <p>Update your password and your account recovery information</p>
                    <div className="cardButtons">
                        <button className="btn btn-small btn-outline-primary" onClick={() => setActiveCardId(CARD_CONTENT_IDS.CREDENTIALS)}>
                            <i className="fa fa-pencil mr-2" /> Manage Credentials
                        </button>
                    </div>
                </Card>
            </div>
        </AccountsTabSection>

        <Modal
            show={!!activeCardId}
            onClose={() => setActiveCardId(null)}
            closeOnOuterClick={false}
            className="accountsSubModal"
            nodeId="root"
        >
            { activeCardId && cardContentItems[activeCardId].children }
        </Modal>
    </section>;
};

export default AccountSettings;
